import React from "react";
import { Box, Typography, Button, Drawer, Stack } from "@mui/material";
import { colors, typography } from "../../../../../../../assets/styles/tokens";

export interface InsightItem {
    label: string;
    icon?: React.ReactNode;
    description: React.ReactNode;
}

interface InsightPopupProps {
    open: boolean;
    onClose: () => void;
    title: string;
    insights: InsightItem[];
}

const InsightPopup: React.FC<InsightPopupProps> = ({
    open,
    onClose,
    title,
    insights,
}) => {
    return (
        <Drawer
            anchor="bottom"
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {
                    borderRadius: "16px 16px 0 0",
                    px: 2,
                    py: 2,
                    pb: 4,
                    maxHeight: "90vh",
                    bgcolor: colors.Base.White.$value,
                },
            }}
        >
            <Box
                sx={{
                    width: 32,
                    height: 4,
                    bgcolor: colors.GrayLightMode[300].$value,
                    borderRadius: 2,
                    mx: "auto",
                    mb: 2,
                }}
            />

            <Typography
                variant="h6"
                sx={{
                    fontWeight: typography.Font_weight.Semibold.$value,
                    color: colors.GrayLightMode[900].$value,
                    textAlign: "center",
                    mb: 3,
                }}
            >
                {title}
            </Typography>

            <Stack spacing={3} sx={{ overflowY: "auto", mb: 3 }}>
                {insights.map((insight, index) => (
                    <Box key={index}>
                        <Typography
                            variant="subtitle2"
                            sx={{
                                fontWeight: typography.Font_weight.Medium.$value,
                                color: colors.GrayLightMode[700].$value,
                                textTransform: "uppercase",
                                mb: 1,
                            }}
                        >
                            {insight.label}
                        </Typography>
                        <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
                            {insight.icon && (
                                <Box sx={{ mt: 0.5, color: colors.GrayLightMode[600].$value }}>
                                    {insight.icon}
                                </Box>
                            )}
                            <Typography
                                variant="body2"
                                sx={{
                                    color: colors.GrayLightMode[600].$value,
                                    lineHeight: 1.5,
                                    fontStyle: "italic",
                                }}
                            >
                                {insight.description}
                            </Typography>
                        </Box>
                    </Box>
                ))}
            </Stack>

            <Button
                fullWidth
                variant="contained"
                onClick={onClose}
                sx={{
                    bgcolor: colors.Purple[500].$value,
                    color: colors.Base.White.$value,
                    py: 1.5,
                    fontWeight: typography.Font_weight.Medium.$value,
                    borderRadius: "4px",
                    boxShadow: "none",
                    "&:hover": {
                        bgcolor: colors.Purple[600].$value,
                        boxShadow: "none",
                    },
                }}
            >
                CLOSE
            </Button>
        </Drawer>
    );
};

export default InsightPopup;
